import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { Modules } from './modules';
import { BugsnagModule } from '@kaiser-software/bugsnag';
import { environment } from '../environments/environment';
import { NxModule } from '@nrwl/nx';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ChassisResourceModule } from '@kaiser-software/chassis-resource';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BugsnagModule.forRoot({
            token: '426c37fcd5d31ad551ae8fcf67ae2a71',
            enabled: environment['bugsnag'],
        }),
        BrowserModule,
        CommonModule,
        HttpModule,
        RouterModule.forRoot([]),

        NxModule.forRoot(),
        StoreModule.forRoot({}),
        EffectsModule.forRoot([]),
        ChassisResourceModule,
        StoreDevtoolsModule.instrument({
            maxAge: 25
        }),

        Modules
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/app.module.ts